<template>
  <div class="timeline-item">
    <div class="timeline-media">
      <span
        class="label label-xl label-light-danger font-weight-bolder text-danger"
        >{{ index }}</span
      >
    </div>
    <div class="timeline-content">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="mr-2">
          <a href class="text-dark-75 text-hover-primary font-weight-bold">{{
            path.title
          }}</a>
          <span class="text-muted ml-2">
            {{ path.startDate | moment("D MMM YYYY") }}
          </span>
          <div class="row mt-2">
            <TagsPills :tagId="t" v-for="t in path.tags" :key="t._id" />
            <span
              class="label label-light-warning font-weight-bolder label-inline ml-2"
              v-if="level"
              >{{ level.name }}</span
            >
          </div>
        </div>
      </div>
      <div v-html="path.description"></div>
      <div v-for="m in path.material" :key="m._id">
        <div class="path b-1">
          <a :href="getUrl(m)" target="_blank" class="non-decoration">
            <h3 class="text-dark text-hover-primary mb-5 font-size-lg">
              {{ m.name }}
            </h3>

            <div class="row d-flex align-items-center">
              <span class="text-dark">
                <div class="symbol symbol-40  mr-0 col-2 mb-0">
                  <span class="symbol-label">
                    <i
                      class="fas fa-chalkboard-teacher text-danger"
                      v-if="m.type === 'Classroom'"
                    ></i>
                    <i
                      class="fas fa-file-pdf text-danger"
                      v-if="m.type === 'Pdf'"
                    ></i>
                    <i
                      class="fas fa-video text-danger"
                      v-if="m.type === 'Video'"
                    ></i>
                    <i
                      class="fas fa-book text-danger"
                      v-if="m.type === 'Book'"
                    ></i>
                  </span>
                </div>
              </span>
              <p class="col-9 mb-0" v-html="m.description"></p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagsPills from "@/view/layout/dashboard/TagsPills";

export default {
  name: "Timeline",
  components: {
    TagsPills
  },
  props: {
    path: { required: true, type: Object },
    index: { required: true, type: Number }
  },
  computed: {
    level() {
      let lvl = this.$store.getters.getLevels.find(
        l => l._id == this.path.level
      );
      return lvl;
    }
  },
  methods: {
    getUrl(material) {
      return material.type == "Pdf"
        ? process.env.VUE_APP_API_URL + material.url
        : material.url;
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin-left: 15px;
}
.path {
  .symbol {
    .symbol-label {
      background: white;
    }
  }
}
</style>
